import type { ServiceError } from 'gpcore-apikit/grpc/types';
import { useProjectStore } from 'gpcore-apikit/store/pinia/project';
import type { BasicProject } from 'gpcore-grpc/gpcore/api/cloud/v1/project_pb';
import useNotifications from 'gpcore-uikit/composables/useNotifications';
import { ref } from 'vue';

export default () => {
  const projectStore = useProjectStore();
  const { addNotification } = useNotifications();
  const isExecutingInviteAccept = ref<boolean>(false);

  const executeProjectInviteAccept = async (project: BasicProject) => {
    isExecutingInviteAccept.value = true;
    try {
      await projectStore.joinProject({
        projectId: project.id,
        accept: true,
      });
    } catch (error) {
      addNotification({
        type: 'danger',
        message: (error as ServiceError).message,
      });
    } finally {
      isExecutingInviteAccept.value = false;
    }
  };

  return {
    isExecutingInviteAccept,
    executeProjectInviteAccept,
  };
};
